(() => {
  if (customElements.get('pipet-shipping-quote')) return;
  const root = window.Shopify?.routes?.root || '/';
  const states = new Set('AC AL AP AM BA CE DF ES GO MA MT MS MG PA PB PR PE PI RJ RN RS RO RR SC SP SE TO'.split(' '));
  const read = async url => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(url, {signal:controller.signal, headers:{Accept:'application/json'}});
      if (!response.ok) throw new Error('Não foi possível consultar agora. Tente novamente.');
      return await response.json();
    } finally { clearTimeout(timer); }
  };
  class ShippingQuote extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input');
      this.button = this.querySelector('[data-quote-submit]');
      this.result = this.querySelector('[data-quote-result]');
      this.product = JSON.parse(this.querySelector('[data-quote-product]')?.textContent || 'null');
      this.input.addEventListener('input', () => {
        this.input.value = this.input.value.replace(/\D/g,'').slice(0,8).replace(/^(\d{5})(\d)/,'$1-$2');
        this.result.replaceChildren();
      });
      this.input.addEventListener('keydown', event => {
        if(event.key === 'Enter'){event.preventDefault();this.calculate();}
      });
      this.button.addEventListener('click', () => this.calculate());
      this.section = this.closest('.shopify-section') || document;
      this.onProductChange = event => {
        if (this.contains(event.target) || !this.product || !this.result.textContent) return;
        if (event.target.matches('input,select')) this.result.textContent = 'Seleção atualizada. Calcule novamente para conferir o frete.';
      };
      this.section.addEventListener('change', this.onProductChange);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
          if (!this.product && this.result.textContent) this.result.textContent = 'Carrinho atualizado. Calcule novamente para conferir o frete.';
        });
      }
    }
    disconnectedCallback() {
      this.unsubscribe?.();
      this.section?.removeEventListener('change', this.onProductChange);
      this.ready = false;
    }
    selection() {
      const forms = [...this.section.querySelectorAll('form[action*="/cart/add"]')];
      const form = forms.find(f => this.product.variants.some(v => String(v.id) === f.querySelector('[name="id"]')?.value));
      const variantId = form?.querySelector('[name="id"]')?.value || new URL(location.href).searchParams.get('variant') || this.product.selected;
      const variant = this.product.variants.find(v => String(v.id) === String(variantId));
      const quantityInput = form?.querySelector('[name="quantity"]') || (form?.id && this.section.querySelector('[name="quantity"][form="'+CSS.escape(form.id)+'"]')) || this.section.querySelector('[name="quantity"]');
      const quantity = Math.max(1,Math.trunc(Number(quantityInput?.value)||1));
      return {variant,quantity,total:Number(variant?.price || this.product.price)*quantity};
    }
    paragraph(text) {
      const p=document.createElement('p');p.textContent=text;this.result.append(p);
    }
    rate(title, price, description, express = false) {
      const row=document.createElement('div');row.className='pipet-shipping-quote__rate'+(express?' pipet-shipping-quote__rate--express':'');
      const label=document.createElement('span');label.textContent=title;
      if(express){const badge=document.createElement('b');badge.className='pipet-shipping-quote__badge';badge.textContent='PADRÃO NA CAPITAL · DE MOTO';label.prepend(badge);}
      const detail=document.createElement('small');detail.textContent=description;label.append(detail);
      const amount=document.createElement('strong');amount.textContent=price===0?'Grátis':new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(price);
      row.append(label,amount);this.result.append(row);
    }
    async calculate() {
      if(this.busy) return;
      const cep=this.input.value.replace(/\D/g,'');
      this.result.replaceChildren();
      if(cep.length!==8){this.paragraph('Digite um CEP com 8 números.');return;}
      const selected = this.product ? this.selection() : null;
      this.busy=true;this.button.disabled=true;this.button.textContent='Consultando…';
      try {
        const [address,cart] = await Promise.all([read('https://viacep.com.br/ws/'+cep+'/json/'), this.product ? Promise.resolve(null) : read(root+'cart.js')]);
        if(this.input.value.replace(/\D/g,'')!==cep) return;
        if(address.erro || !states.has(address.uf)) throw new Error('CEP não encontrado. Confira os números e tente novamente.');
        if(this.product && JSON.stringify(this.selection())!==JSON.stringify(selected)) throw new Error('Seleção atualizada. Calcule novamente para conferir o frete.');
        const total = this.product ? selected.total : cart.total_price;
        const free = total >= 25000;
        this.paragraph(address.localidade+' / '+address.uf);
        if(this.product) this.paragraph('Estimativa para '+selected.quantity+(selected.quantity===1?' unidade':' unidades')+' deste produto'+(selected.variant?.title && selected.variant.title!=='Default Title'?' — '+selected.variant.title:'')+'.');
        else this.paragraph(cart.item_count?'Valores para os itens atuais do carrinho:':'Tabela de frete para este CEP:');
        const capital = address.uf==='SP' && address.localidade==='São Paulo';
        if(capital) this.rate('Entrega padrão de moto — São Paulo capital',free?0:16.90,'No mesmo dia para pedidos aprovados até 15h, de segunda a sexta, exceto feriados. Após esse horário, no próximo dia útil.',true);
        this.rate('Entrega padrão — '+(address.uf==='SP'?'Estado de SP':'Brasil'),free?0:address.uf==='SP'?18.90:31.90,(address.uf==='SP'?'4':'6')+' dias úteis, incluindo a preparação do pedido.');
        this.paragraph('Frete grátis a partir de R$ 250 após descontos. Descontos aplicados à compra podem alterar a elegibilidade; confira o total no checkout.');
      } catch(error) {
        this.paragraph(error.name==='AbortError'?'A consulta ao CEP demorou mais que o esperado. Tente novamente.':error.message);
      } finally {this.busy=false;this.button.disabled=false;this.button.textContent='Calcular';}
    }
  }
  customElements.define('pipet-shipping-quote',ShippingQuote);
})();
